export default {
    methods: {
        // zwraca czas trwania programu na podstawie daty rozpoczęcia i zakończenia
        getProgramDuration(start, end) {
            if (start && end) {
                const startD = new Date(start);
                const endD = new Date(end);
                const duration = Math.abs(
                    Math.round((endD - startD) / 1000 / 60)
                );
                return duration;
            }
            return 10; // default value
        }
    }
};
